export const FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME = 'frontLoggedIn';
export const FRONT_USER_ROLE_COOKIE_NAME= 'userRole';
export const FRONT_USER_PASSWORD_IN_COOKIE_NAME='userPassword';
export const FRONT_USER_LAST_NAME_COOKIE_NAME='userLastName';
export const FRONT_USER_FIRST_NAME_COOKIE_NAME='userFirstName';
export const FRONT_USER_COUNTRY_COOKIE_NAME='userCountry';
export const FRONT_USER_AFFILIATION_COOKIE_NAME='userAffiliation';
export const FRONT_USER_STATUS_COOKIE_NAME='userStatus';
export const FRONT_USER_EMAIL_COOKIE_NAME='userEmail';
export const FRONT_USER_LANG_COOKIE_NAME='userLang';
export const FRONT_USER_QUERY_LANG_COOKIE_NAME='userQueryLang';
export const FRONT_USER_CORPUS_FILTER='userCorpusFilter'
export const FRONT_USER_SELECTED_CORPORA='userSelectedCorpora'
